import { render, staticRenderFns } from "./FormulaList.vue?vue&type=template&id=47acc657&scoped=true"
import script from "./FormulaList.vue?vue&type=script&lang=js"
export * from "./FormulaList.vue?vue&type=script&lang=js"
import style0 from "./FormulaList.vue?vue&type=style&index=0&id=47acc657&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47acc657",
  null
  
)

export default component.exports